<template>
  <el-dropdown>
    <el-button type="primary" size="mini" round>
      {{$t('eventLinks.title')}}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown" class="predefined-dropdown">
      <el-dropdown-item @click.native="goLink(whiteLabel.whitelabelLiveDomain +'/'+whiteLabel.slug)">{{ $t('eventLinks.webApp') }}</el-dropdown-item>
      <el-dropdown-item @click.native="goLink(whiteLabel.iosLink)">{{ $t('eventLinks.iosApp') }}</el-dropdown-item>
      <el-dropdown-item @click.native="goLink(whiteLabel.androidLink)">{{ $t('eventLinks.androidApp') }}</el-dropdown-item>
      <el-dropdown-item @click.native="goLink(form.link)" :divided="index == 0" v-for="(form, index) in registerFormList" :key="form.id">{{ form.title }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    goLink(link) {
      if (!link.includes("https://") && !link.includes("http://")) {
        link = "https://" + link;
      } else if (link.includes("http://")) {
        link = link.replace("http://", "https://");
      }

      window.open(link, "_blank");
    }
  },
  computed: {
    whiteLabel() {
      return this.$store.getters.getEventWhiteLabelSettings;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    },
    currentEvent() {
      return this.$store.getters.currentEvent;
    },
    organisation() {
      return this.$store.getters.getCurrentOrganization;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/eventinfo/EventLinks.vue